import React, { useState } from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import Text from '../../../../../General/Text';
import Button from '../../../../../General/Button';
import {
  ContainerStyled,
  HeaderStyled,
  HandleStyled,
  TextStyled,
  ContentStyled,
  TextEnrolTDC,
  EnrolAction,
} from './style/MethodStyled';
import { ReactComponent as ArrowNavIcon } from '../../../../../../images/ui/arrow-nav.svg';
import { ReactComponent as PlusIcon } from '../../../../../../images/bolsas/plus.svg';
import CardNumberComponent from '../../../../../WomPay/CardNumberComponent';

const WompayMethod = ({ wompayCard, buyCallback, active }) => {
  const wompayRegister = wompayCard.id !== '';
  const [toggled, setToggle] = useState(false);

  const clickHandler = () => {
    setToggle(!toggled);
  };

  const buyHandler = () => {
    buyCallback('WOMPAY', wompayCard);
  };

  const wompayActive = () => {
    return (
      <ContentStyled
        data-testid="toggle-content"
        key="content"
        initial="collapsed"
        animate="open"
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 },
        }}
        transition={{ duration: 0.3 }}
        style={{ marginTop: '20px' }}
      >
        <CardNumberComponent
          cardType={wompayCard.vendor}
          lastFour={wompayCard.lastFour}
        />
        <Button
          color="bubbleGum"
          maxWidth="100%"
          disabled={!active}
          click={buyHandler}
          margin={active ? '20px 0px 0px' : '20px 0px 0px 0px'}
        >
          PAGAR
        </Button>
      </ContentStyled>
    );
  };

  const wompayEnrol = () => {
    return (
      <ContentStyled
        data-testid="toggle-content"
        key="content"
        initial="collapsed"
        animate="open"
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 },
        }}
        transition={{ duration: 0.3 }}
      >
        <TextEnrolTDC>
          ¡Pagos más rápidos! Utiliza tu tarjeta de crédito en WOM y paga tu
          próxima compra en un click
        </TextEnrolTDC>
        <EnrolAction
          // Enviar parametros de bolsa en el state de navigate, abajo un ejemplo:
          //         navigate('/wompay/success', {
          //           state: { ...response, idCard: wompayCard.id },
          //         });
          // revisar en pages/wompay/success.js como se reciben los state
          onClick={() => {
            navigate('/marketplace/metodos-de-pago/enrol/');
          }}
        >
          <p>Agregar tarjeta de crédito</p>
          <PlusIcon />
        </EnrolAction>
      </ContentStyled>
    );
  };

  return (
    <ContainerStyled>
      <HeaderStyled>
        <TextStyled>
          <Text
            text="Tarjeta de crédito"
            color="#2D1441"
            size="18px"
            weight="500"
          />
        </TextStyled>
        <HandleStyled
          data-testid="toggle-handler"
          onClick={clickHandler}
          toggled={toggled}
        >
          <ArrowNavIcon />
        </HandleStyled>
      </HeaderStyled>
      <AnimatePresence initial={false}>
        {toggled && wompayRegister && wompayActive()}
        {toggled && !wompayRegister && wompayEnrol()}
      </AnimatePresence>
    </ContainerStyled>
  );
};

WompayMethod.propTypes = {
  wompayCard: PropTypes.shape({
    maxAmount: PropTypes.number,
    patActivated: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    lastname: PropTypes.string,
    lastFour: PropTypes.string,
    vendor: PropTypes.string,
  }).isRequired,
  buyCallback: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};

export default WompayMethod;
